import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-status-dropdown',
    templateUrl: './status-dropdown.component.html',
    styleUrls: ['./status-dropdown.component.css'],
    standalone: false
})
export class StatusDropdownComponent {

  @Input() statusFilters: { label: string; value: string }[] = [];
  @Input() statusFilter: string = '';
  @Input() showClear: boolean = true;
  @Output() statusFilterChange = new EventEmitter<any>();
  @Output() onChange = new EventEmitter<any>();
  @Input() showSelectedText = true;

  onStatusChange(event: any) {
    this.statusFilter = event.value;
    this.statusFilterChange.emit(this.statusFilter);
    this.onChange.emit(event);
  }

  transform(value: any): string {
    if (value === true || value === 'true' || value === 'ACTIVE' || value === 'active') {
      return 'active';
    }
    if (value === false || value === 'false' || value === 'INACTIVE' || value === 'inactive') {
      return 'inactive';
    }
    return (value || '').toString().toLowerCase();
  }
}
